import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../../components/Buttons/Button.js';
import { getMessage } from '../../i18n/messages.js';
export const DoneScreen = ({ className, onNavigateHome }) => {
    const handleNavigateHome = onNavigateHome ?? (() => {
        window.location.href = '/';
    });
    return (_jsxs("div", { className: className, children: [_jsx("h2", { className: 'mb-2', children: getMessage('en-US', 'registrationComplete') }), _jsx(Button, { htmlType: "button", onClick: () => {
                    handleNavigateHome();
                }, children: getMessage('en-US', 'goToHome') })] }));
};
//# sourceMappingURL=DoneScreen.js.map